const PropTypes = require('prop-types');
const React = require('react');

const { formatText } = require('core/i18n').i18n;
//components
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const AutonomousTaxForm = require('../AutonomousTaxForm/autonomousTaxForm');
const InvestmentTaxForm = require('../InvestmentTaxForm/investmentTaxForm');
require('./taxData.scss');

class TaxData extends React.Component {

    constructor(props) {
        super(props);
        this.FAMILIAR_TAX = 1;
        this.AUTONOMOUS_TAX = 2;
        this.INVESTMENT_TAX = 3;
        let initialState;
        if (this.props.values) {
            initialState = this.props.values[0];
        } else {
            initialState = {
                selectedOption: this.FAMILIAR_TAX,
                component_id: 'taxData'
            };
        }
        this.state = initialState;

        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.onDataReceiver = this.onDataReceiver.bind(this);
    }

    onDataReceiver(data) {
        this.props.dataReceiver([this.state, data]);
    }

    buildRadioButton(radioButton) {
        return (<RadioButton
            label={radioButton.label}
            value={radioButton.value}
            className="block-step__radio"/>);
    }


    buildSelectedForm() {
        switch (this.state.selectedOption) {
            case this.FAMILIAR_TAX:
                return null;
            case this.AUTONOMOUS_TAX:

                return (<AutonomousTaxForm values={this.props.values ? this.props.values[1] : null} dataReceiver={this.onDataReceiver}/>);
            case this.INVESTMENT_TAX:
                return (<InvestmentTaxForm values={this.props.values ? this.props.values[1] : null} dataReceiver={this.onDataReceiver}/>);
        }
    }


    handleRadioButtonChange(event) {
        event = Number(event);
        this.setState({selectedOption: event});
    }

    render() {
        let radioOptions = [];
        this.props.radioOptions.forEach( option => {
            radioOptions.push(this.buildRadioButton(option));
        });
        let selectedForm = this.buildSelectedForm();
        switch (this.props.type) {
            case 'single':
                return (
                    <div className="tax-data">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountTaxDataFirstRadioButtonGroupTitle')}</div>
                        <RadioButtonGroup
                            name="tax"
                            key="taxSingle"
                            idPrefix="taxSelected"
                            selectedValue={this.state.selectedOption}
                            className="block-step__radio-group"
                            onChange={this.handleRadioButtonChange}>
                            {radioOptions}
                        </RadioButtonGroup>
                        <div>
                            {selectedForm}
                        </div>
                    </div>);
            case 'form':
                return (
                    <div className="tax-data">
                        <div className="ok-slider__text">{formatText('contractsView-checkingAccountTaxDataSecondRadioButtonGroupTitle')}</div>
                        <div className="ok-slider__slider-box">
                            <RadioButtonGroup
                                name="tax"
                                key="taxForm"
                                idPrefix="taxSelected"
                                selectedValue={this.state.selectedOption}
                                className="block-step__radio-group"
                                onChange={this.handleRadioButtonChange}>
                                {radioOptions}
                            </RadioButtonGroup>
                            <div>
                                {selectedForm}
                            </div>
                        </div>
                    </div>
                )
        }
        return (
            <div>

            </div>
        );
    }
}

TaxData.propTypes = {
    dataReceiver: PropTypes.func, //dataReceiver function
    radioOptions: PropTypes.array, //The component source
    values: PropTypes.any,
    type: PropTypes.string
};

module.exports = TaxData;